import React, { Component } from 'react';
import WindowOptionButton from '../WindowOptionButton';
import './styles.css';
class WindowDisabledButton extends Component {
	render() {
		return (
			<WindowOptionButton
				className="window-disabled-button"
				backgroundColor="grey"
				{...this.props}
			/>
		);
	}
}

export default WindowDisabledButton;
